import { SyntheticEvent } from 'react';

import { Autocomplete, AutocompleteChangeReason, Typography } from '@mui/material';

import { Spacer } from 'src/components';
import { AutoCompleteOptionType } from 'src/components/FormikComponents/NPIAutoComplete';

import RenderInputTextField from './RenderInputTextField';

interface MerchantSelectFieldsProps {
    merchant: AutoCompleteOptionType;
    merchantAccountNumber: AutoCompleteOptionType;
    merchantOptions: AutoCompleteOptionType[];
    merchantAccountNumberOptions: AutoCompleteOptionType[];
    disabled?: boolean;
    handleChangeMerchant: (
        value: AutoCompleteOptionType,
        reason?: AutocompleteChangeReason,
        _event?: SyntheticEvent
    ) => void;
    handleChangeMerchantAccountNumber: (
        value: AutoCompleteOptionType,
        reason?: AutocompleteChangeReason,
        _event?: SyntheticEvent
    ) => void;
}
function MerchantSelectFields({
    merchant,
    merchantAccountNumber,
    merchantOptions,
    handleChangeMerchant,
    merchantAccountNumberOptions,
    handleChangeMerchantAccountNumber,
    disabled,
}: MerchantSelectFieldsProps) {
    return (
        <>
            <Typography fontWeight="bold">Merchant</Typography>
            <Autocomplete
                data-testid={'merchant-autocomplete'}
                value={merchant ?? null}
                options={merchantOptions}
                getOptionLabel={(option) => {
                    return option.label;
                }}
                onChange={(
                    _event: SyntheticEvent,
                    newValue: AutoCompleteOptionType,
                    reason: AutocompleteChangeReason
                ) => {
                    handleChangeMerchant(newValue, reason, _event);
                    handleChangeMerchantAccountNumber(
                        merchantAccountNumberOptions.find((option) => {
                            return option.value === (newValue?.value ?? newValue?.id);
                        }),
                        reason,
                        _event
                    );
                }}
                disabled={disabled}
                renderInput={(params) => {
                    return <RenderInputTextField params={params} disabled={disabled} />;
                }}
            />
            <Spacer padding={1} />
            <Typography fontWeight="bold">Merchant Account Number</Typography>
            <Autocomplete
                data-testid={'merchant-account-number-autocomplete'}
                value={merchantAccountNumber ?? null}
                options={merchantAccountNumberOptions}
                getOptionLabel={(option) => {
                    return option.label;
                }}
                disabled={disabled}
                onChange={(
                    _event: SyntheticEvent,
                    newSelectedMerchantAccountNumberOption: AutoCompleteOptionType,
                    reason: AutocompleteChangeReason
                ) => {
                    handleChangeMerchantAccountNumber(
                        newSelectedMerchantAccountNumberOption,
                        reason,
                        _event
                    );
                    handleChangeMerchant(
                        merchantOptions.find((option) => {
                            return (
                                (option.value ?? option.id) ===
                                newSelectedMerchantAccountNumberOption?.value
                            );
                        })
                    );
                }}
                renderInput={(params) => {
                    return <RenderInputTextField params={params} disabled={disabled} />;
                }}
            />
        </>
    );
}
export default MerchantSelectFields;
